import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowCounterClockwise } from "@phosphor-icons/react";
import api from "@/lib/api";

const when = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

function BackupRow({ b, onRestore, busy }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 p-3 text-xs border-t border-zinc-200" data-testid={`clean-start-backup-${b.id}`}>
      <div>
        <div className="font-bold">Clean start on {when(b.created_at)}</div>
        <div className="text-zinc-600">
          {b.total.toLocaleString()} records removed by {b.actor_email || "an owner"} · undo until {when(b.expires_at)}
          {b.restored_at ? ` · undone ${when(b.restored_at)}` : ""}
        </div>
      </div>
      {b.can_restore && (
        <button onClick={() => onRestore(b)} disabled={busy} data-testid={`clean-start-undo-${b.id}`}
          className="border border-black px-3 py-1.5 text-[10px] uppercase tracking-widest inline-flex items-center gap-1 hover:bg-black hover:text-white disabled:opacity-40">
          <ArrowCounterClockwise size={11} weight="bold" /> {busy ? "Restoring…" : "Undo clean start"}
        </button>
      )}
    </div>
  );
}

export default function CleanStartBackups({ refreshKey, onRestored }) {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => {
    api.get("/admin/clean-start/backups").then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  const restore = async (b) => {
    if (!window.confirm("Put back everything this clean start removed? Changes made since then to the same records will be replaced.")) return;
    setBusy(true);
    try {
      const r = await api.post(`/admin/clean-start/backups/${b.id}/restore`);
      const warn = r.data?.warnings?.length;
      toast[warn ? "warning" : "success"](warn ? `Restored with ${warn} warning(s)` : "Everything was put back");
      load();
      onRestored?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Undo failed");
    } finally {
      setBusy(false);
    }
  };

  if (!rows.length) return null;
  return (
    <div className="brut-card bg-white mt-6" data-testid="clean-start-backups">
      <div className="p-3 font-chivo font-bold uppercase tracking-tight">Clean start undo copies</div>
      {rows.map((b) => <BackupRow key={b.id} b={b} onRestore={restore} busy={busy} />)}
    </div>
  );
}
